<template>
  <b-alert
    :show="dismissCountDown"
    :variant="variant"
    class="text-center"
    dismissible
    @dismissed="clearFlashAlert"
  >
    {{ message }}
  </b-alert>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  data() {
    return {
      dismissSecs: 7,
    }
  },
  computed: {
    ...mapGetters([
      'message',
      'variant',
      'hasMessage',
    ]),
    dismissCountDown: function () {
      return this.hasMessage ? this.dismissSecs : 0
    },
  },
  methods: {
    ...mapActions(['clearFlashAlert']),
  },
}
</script>
